<script>
import AgreedItem from "@/components/clientNegotiations/AgreedItem";
import AgreedContent from "@/components/clientNegotiations/AgreedContent";
import Multiselect from "vue-multiselect";
import {cloneDeep} from "lodash";
import axios from "axios";
import BoardColumn from "./dummy/BoardColumn";

export default {
  page: {
    title: "Content Board"
  },

  components: {
    AgreedItem,
    AgreedContent,
    Multiselect,
    BoardColumn
  },

  data() {
    return {
      title: "Content Board",
      agreedPosts: [],

      nonsubmitted: [],
      draft: [],
      approved: [],
      published: [],
      showModal: false,
      modalTitle: '',
      modalAgreement: {},

      availableCampaigns: {},
      availableCompanies: {},
      filters: {},
    };
  },
  computed: {
    clientId() {
      return this.$route.params.clientId;
    },
  },
  async created() {
    this.$store.commit('loader/START_LOADING');
    try {
      const {data} = await axios.get(`/admin/client/${this.clientId}/agreed-post`);
      this.agreedPosts = data;
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e)
    } finally {
      this.$store.commit('loader/END_LOADING');
    }

    this.mapArrays();
  },
  methods: {
    mapArrays() {
      Object.keys(this.agreedPosts).forEach(key => {
        // eslint-disable-next-line no-unused-vars
        for (let [_, agreedPost] of Object.entries(this.agreedPosts[key])) {
          this.availableCampaigns[agreedPost.campaign_id] = {
            'campaign_id': agreedPost.campaign_id,
            'campaign_name': agreedPost.campaign_name,
          }
          this.availableCompanies[agreedPost.picture_alt] = {
            'picture_alt': agreedPost.picture_alt,
            'picture_url': agreedPost.picture_url,
          }
        }

        if (key === 'nonsubmitted') {
          this.nonsubmitted = cloneDeep(this.agreedPosts[key]);
        } else if (key === 'draft') {
          this.draft.push(...cloneDeep(this.agreedPosts[key]));
        } else if (key === 'approved') {
          this.approved.push(...cloneDeep(this.agreedPosts[key]));
        } else if (key === 'published') {
          this.published.push(...cloneDeep(this.agreedPosts[key]));
        }
        this.nonsubmitted = this.nonsubmitted.sort((a, b) => new Date(b.pool_entered) - new Date(a.pool_entered));
        this.draft = this.draft.sort((a, b) => new Date(b.pool_entered) - new Date(a.pool_entered));
        this.approved = this.approved.sort((a, b) => new Date(b.pool_entered) - new Date(a.pool_entered));
        this.published = this.published.sort((a, b) => new Date(b.pool_entered) - new Date(a.pool_entered));
      });
    },
    async openModal(agreementId) {
      this.$store.commit('loader/START_LOADING');
      try {
        const {data} = await axios.get(`/agreed-post/${agreementId}`);
        this.modalAgreement = data;
        this.modalTitle = this.modalAgreement.campaign_name;
        this.showModal = true;
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e)
      } finally {
        this.$store.commit('loader/END_LOADING');
      }
    },
    closeModal() {
      this.clearAgreement()
    },
    clearAgreement() {
      this.modalAgreement = {};
      this.showModal = false;
    },
    checkForAgreementIdInURL() {
      if (this.$route.params.id) {
        this.openModal(this.$route.params.id);
      } else {
        this.clearAgreement();
      }
    },
    filterAgreedPosts(agreedPosts) {
      return agreedPosts.filter(agreedPost => {
        let show = true;
        if (this.filters.campaign && agreedPost.campaign_id !== this.filters.campaign) {
          show = false;
        }
        if (this.filters.companies && this.filters.companies.length > 0 && !this.filters.companies.includes(agreedPost.picture_alt)) {
          show = false;
        }

        return show;
      })
    },
  }
}
</script>

<template>
  <div>
    <div>
      <div class="form-group row">
        <div class="col-md-4">
          <div class="page-title-box d-flex align-items-center justify-content-between">
            <h4 class="mb-0 font-size-18">{{ title }}</h4>
          </div>
        </div>
        <div class="col-md-1 d-flex align-items-center justify-content-end">
          <span class="d-none d-md-block font-size-16 " style="margin-right: -15px">
            <i class="fas fa-filter"></i>
          </span>
        </div>
        <div class="col-md-3 mb-2 mb-md-0">
          <multiselect selectLabel="" placeholder="Campaign" selectedLabel="" v-model="filters.campaign" :custom-label="index => availableCampaigns[index].campaign_name" :options="Object.keys(availableCampaigns)" :multiple="false">
            <template slot="option" slot-scope="{ option }" v-if="availableCampaigns[option]">
              <span class="option__desc pl-2">
                <span class="option__title">{{ availableCampaigns[option].campaign_name }}</span>
              </span>
            </template>
          </multiselect>
        </div>
        <div class="col-md-4">
          <multiselect selectLabel="" placeholder="Clients" selectedLabel="" v-model="filters.companies" :custom-label="index => availableCompanies[index].picture_alt" :options="Object.keys(availableCompanies)" :multiple="true">
            <template slot="option" slot-scope="{ option }" v-if="availableCompanies[option]">
              <img :src="`${availableCompanies[option].picture_url}`" alt
                   class="option__image img-fluid mx-auto " style="border-radius: 50%; width: 30px"/>
              <span class="option__desc pl-2">
                    <span class="option__title">{{ availableCompanies[option].picture_alt }}</span>
                  </span>
            </template>
          </multiselect>
        </div>
      </div>
    </div>

    <div class="drag-container">
      <div class="row drag-list">

        <!--Nonsubmitted-->
        <BoardColumn heading="Not submitted" class="col-md-6 col-xl-3">
          <transition-group tag="div" class="pool-card-body" name="list">
            <AgreedItem v-for="item in filterAgreedPosts(nonsubmitted)" :key="item._id" @click="openModal" :item="item"
                        pool-name="offer" :class="['list-item']"/>
          </transition-group>
        </BoardColumn>

        <!--Draft-->
        <BoardColumn heading="Draft" class="col-md-6 col-xl-3">
          <transition-group tag="div" class="pool-card-body" name="list">
            <AgreedItem v-for="item in filterAgreedPosts(draft)" :key="item._id" @click="openModal" :item="item" pool-name="draft"
                        :class="['list-item']"/>
          </transition-group>
        </BoardColumn>

        <!--Approved-->
        <BoardColumn heading="Approved" class="col-md-6 col-xl-3">
          <transition-group tag="div" class="pool-card-body" name="list">
            <AgreedItem v-for="item in filterAgreedPosts(approved)" :key="item._id" @click="openModal" :item="item"
                        pool-name="draft" :class="['list-item']"/>
          </transition-group>
        </BoardColumn>

        <!--Published-->
        <BoardColumn heading="Published" class="col-md-6 col-xl-3">
          <transition-group tag="div" class="pool-card-body" name="list">
            <AgreedItem v-for="item in filterAgreedPosts(published)" :key="item._id" @click="openModal" :item="item"
                        pool-name="draft" :class="['list-item']"/>
          </transition-group>
        </BoardColumn>


      </div>
      <b-modal body-class="p-0" content-class="border-0" @hidden="closeModal" v-model="showModal" size="lg" centered
               hide-footer hide-header>
        <AgreedContent :agreed-post="modalAgreement" @closeModal="showModal = false"/>
      </b-modal>
    </div>
  </div>
</template>

<style scoped>

.list-item {
  transition: opacity 0.6s, transform 0.6s;
}

.list-enter, .list-leave-to
  /* .list-complete-leave-active below version 2.1.8 */
{
  opacity: 0;
  transform: translateY(-30px);
}

.list-leave-active {
  position: absolute;
  width: calc(100% - 40px);
  opacity: 0;
}
</style>
